(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artzova-subject-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('artzova-subject-recommendations')) {
    customElements.define('artzova-subject-recommendations', class extends HTMLElement {
      connectedCallback() {
        const grid = this.querySelector('[data-artzova-recommendation-grid]');
        const template = this.querySelector('[data-artzova-recommendation-candidates]');
        if (!grid || !template || this.dataset.randomized === 'true') return;
        const candidates = Array.from(template.content.children).filter((card) => card.dataset.artworkId !== this.dataset.currentProduct);
        for (let index = candidates.length - 1; index > 0; index--) {
          const randomIndex = Math.floor(Math.random() * (index + 1));
          [candidates[index], candidates[randomIndex]] = [candidates[randomIndex], candidates[index]];
        }
        if (!candidates.length) return;
        const fragment = document.createDocumentFragment();
        candidates.slice(0, 4).forEach((card) => fragment.append(card.cloneNode(true)));
        grid.replaceChildren(fragment);
        this.dataset.randomized = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artzova-welcome-popup"]) return;
  try {
    
  document.querySelectorAll('[data-artzova-welcome-popup]').forEach((popup) => {
    if (popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const storageKey = 'artzova-welcome-offer-v1';
    const timerStartKey = 'artzova-welcome-offer-timer-start-v1';
    const closeButton = popup.querySelector('[data-welcome-close]');
    const copyButton = popup.querySelector('[data-welcome-copy]');
    const popupImage = popup.querySelector('[data-welcome-image]');
    const success = popup.querySelector('[data-welcome-success="true"]') !== null;
    const designMode = popup.dataset.designMode === 'true';
    const delay = Number(popup.dataset.delay) || 60000;

    const readOfferState = () => {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || 'null');
      } catch (error) {
        return null;
      }
    };

    const writeOfferState = (state, days) => {
      try {
        const value = { state };
        if (days) value.expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
        localStorage.setItem(storageKey, JSON.stringify(value));
      } catch (error) {
        return;
      }
    };

    const stateIsActive = () => {
      const offerState = readOfferState();
      return Boolean(
        offerState &&
          ['shown', 'dismissed', 'subscribed'].includes(offerState.state) &&
          (!offerState.expiresAt || offerState.expiresAt > Date.now())
      );
    };

    const hydratePopupImage = () => {
      if (!popupImage || popupImage.dataset.loaded === 'true') return;
      if (popupImage.dataset.srcset) popupImage.srcset = popupImage.dataset.srcset;
      if (popupImage.dataset.src) popupImage.src = popupImage.dataset.src;
      popupImage.dataset.loaded = 'true';
    };

    const openPopup = (force = false) => {
      if (popup.open || (!force && stateIsActive())) return;
      hydratePopupImage();
      if (typeof popup.showModal === 'function') {
        popup.showModal();
      } else {
        popup.setAttribute('open', '');
      }
      if (!force) writeOfferState('shown');
      try {
        localStorage.removeItem(timerStartKey);
      } catch (error) {
        return;
      }
    };

    if (success) {
      writeOfferState('subscribed', 365);
      openPopup(true);
    } else if (designMode) {
      openPopup(true);
    } else if (!stateIsActive()) {
      let timerStartedAt = Date.now();
      try {
        const storedStart = Number(localStorage.getItem(timerStartKey));
        if (storedStart > 0) {
          timerStartedAt = storedStart;
        } else {
          localStorage.setItem(timerStartKey, String(timerStartedAt));
        }
      } catch (error) {
        timerStartedAt = Date.now();
      }
      const remainingDelay = Math.max(0, delay - (Date.now() - timerStartedAt));
      window.setTimeout(() => openPopup(false), remainingDelay);
    }

    closeButton?.addEventListener('click', () => {
      writeOfferState('dismissed');
      popup.close();
    });

    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
    });

    copyButton?.addEventListener('click', async () => {
      const originalLabel = copyButton.textContent;
      try {
        await navigator.clipboard.writeText(copyButton.dataset.code);
        copyButton.textContent = copyButton.dataset.copiedLabel;
        window.setTimeout(() => {
          copyButton.textContent = originalLabel;
        }, 1800);
      } catch (error) {
        return;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
